"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = void 0;
var _theme = require("../../../theme");
var useStyles = (0, _theme.makeStyles)(function (_ref) {
  var typography = _ref.typography,
    background = _ref.background;
  return {
    root: {
      '@global': {
        '.MuiTextField-root': {
          '& .MuiInputBase-input': {
            fontSize: '1rem',
            padding: '0.375rem 0.75rem',
            height: '2.84rem',
            boxSizing: 'border-box'
          },
          '& .MuiInputLabel-root': {
            fontSize: '1rem'
          }
        },
        '.MuiOutlinedInput-root': {
          lineHeight: 1.5,
          height: '2.84rem',
          fontWeight: typography.fontWeightLight,
          backgroundColor: background.primary
        },
        '.MuiFilledInput-root': {
          fontSize: '14px',
          lineHeight: 1.5,
          fontWeight: typography.fontWeightLight,
          borderRadius: '5px',
          height: 50,
          backgroundColor: 'rgb(247, 247, 247, 0.13)',
          '&:after, &:before': {
            content: 'none'
          },
          '&:hover, &.Mui-focused': {
            backgroundColor: 'rgb(247, 247, 247, 0.13)'
          },
          '& .MuiInputBase-input': {
            marginLeft: '10px',
            fontSize: '14px',
            color: 'white',
            padding: '0.375rem 0.75rem',
            height: '50px',
            lineHeight: 1.35,
            fontWeight: typography.fontWeightLight
          }
        }
      }
    }
  };
}, {
  name: 'APInput'
});
exports.useStyles = useStyles;